import React from 'react';

import {RadioButton} from './RadioButton';
import PropTypes from "prop-types";
import {convertLabelTextToDataTestId} from "../convertLabelTextToDataTestId";

const RadioButtonGroup = ({
                              className = 'switches-radio',
                              callback,
                              radioButtonOptions,
                              selectedValue,
                              disabledRadioButtonOptions = [],
                              displayCheckIcon = false
                          }) =>
    <div data-testid={'radio-button-group-container'} className={className}>
        <form className={'radio-button-group-form'} data-testid={'radio-button-group'}>
            {radioButtonOptions.map((option, index) => {
                const isDisabled = disabledRadioButtonOptions.includes(option);
                    return <RadioButton
                        dataTestId={convertLabelTextToDataTestId(option, 'radio-button')}
                        disabled={isDisabled}
                        key={index}
                        index={index}
                        value={option}
                        currentValue={selectedValue}
                        onChange={callback}
                        displayCheckIcon={displayCheckIcon}
                    />
                }
            )}
        </form>
    </div>

RadioButtonGroup.propTypes = {
    className: PropTypes.string,
    callback: PropTypes.func,
    displayCheckIcon: PropTypes.bool,
    radioButtonOptions: PropTypes.array,
    selectedValue: PropTypes.string,
    disabledRadioButtonOptions: PropTypes.array
};

export {RadioButtonGroup};